var map = {
	"./af.json": 919,
	"./am.json": 920,
	"./ar.json": 921,
	"./az.json": 922,
	"./be.json": 923,
	"./bg.json": 924,
	"./bn.json": 925,
	"./bs.json": 926,
	"./ca.json": 927,
	"./cs.json": 928,
	"./cy.json": 929,
	"./da.json": 930,
	"./de.json": 931,
	"./dv.json": 932,
	"./el.json": 933,
	"./en.json": 934,
	"./es.json": 935,
	"./et.json": 936,
	"./eu.json": 937,
	"./fa.json": 938,
	"./fi.json": 939,
	"./fr.json": 940,
	"./gl.json": 941,
	"./ha.json": 942,
	"./he.json": 943,
	"./hi.json": 944,
	"./hr.json": 945,
	"./hu.json": 946,
	"./hy.json": 947,
	"./id.json": 948,
	"./is.json": 949,
	"./it.json": 950,
	"./ja.json": 951,
	"./ka.json": 952,
	"./kk.json": 953,
	"./km.json": 954,
	"./ko.json": 955,
	"./ku.json": 956,
	"./ky.json": 957,
	"./lt.json": 958,
	"./lv.json": 959,
	"./mk.json": 960,
	"./ml.json": 961,
	"./mn.json": 962,
	"./ms.json": 963,
	"./nb.json": 964,
	"./nl.json": 965,
	"./nn.json": 966,
	"./no.json": 967,
	"./pl.json": 968,
	"./ps.json": 969,
	"./pt.json": 970,
	"./ro.json": 971,
	"./ru.json": 972,
	"./sd.json": 973,
	"./sk.json": 974,
	"./sl.json": 975,
	"./so.json": 976,
	"./sq.json": 977,
	"./sr.json": 978,
	"./sv.json": 979,
	"./sw.json": 980,
	"./ta.json": 981,
	"./tg.json": 982,
	"./th.json": 983,
	"./tr.json": 984,
	"./tt.json": 985,
	"./ug.json": 986,
	"./uk.json": 987,
	"./ur.json": 988,
	"./uz.json": 989,
	"./vi.json": 990,
	"./zh.json": 991
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 918;